import { Button, TextField } from '@mui/material';
import { useMutation } from '@tanstack/react-query';
import { FormProvider, useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';

import { FormSection } from '@/components/form-elements/FormSection';
import { TextFieldSelect } from '@/components/form-elements/TextFieldSelect';
import { SidebarLayout } from '@/components/layouts/SidebarLayout';
import { useSetValidationErrors } from '@/hooks/useSetValidationErrors';
import { CreateUserDto, UserRole, UsersService } from '@/services/api';

type FormData = CreateUserDto;

export function CreateUserPage() {
  const navigate = useNavigate();

  const methods = useForm<FormData>();
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = methods;
  const { setValidationErrors } = useSetValidationErrors(methods.setError);

  const { mutate } = useMutation({
    mutationFn: (formData: FormData) => UsersService.create({ requestBody: formData }),
    onSuccess: (user) => navigate(`/beratung/benutzerinnen/${user.id}`),
    onError: setValidationErrors,
  });

  return (
    <SidebarLayout>
      <FormProvider {...methods}>
        <form
          id="main-form"
          onSubmit={handleSubmit((data) => {
            mutate(data);
          })}
        >
          <FormSection title="Benutzer/in erstellen">
            <TextField
              label="E-Mail"
              type="email"
              {...register('email', { required: true })}
              error={!!errors.email}
              helperText={errors?.email?.message}
            />

            <TextFieldSelect label="Rolle" name="role" i18nKey="UserRole" options={Object.values(UserRole)} />
          </FormSection>

          <Button type="submit" variant="contained" size="large">
            Erstellen
          </Button>
        </form>
      </FormProvider>
    </SidebarLayout>
  );
}
